module.exports = __webpack_public_path__ + "img/enemy.8700f42b.png";